import { render } from "./PartLogisticsDetail.vue?vue&type=template&id=3eff7356&scoped=true&bindings={}"
import script from "./PartLogisticsDetail.vue?vue&type=script&lang=ts"
export * from "./PartLogisticsDetail.vue?vue&type=script&lang=ts"

import "./PartLogisticsDetail.vue?vue&type=style&index=0&id=3eff7356&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3eff7356"

export default script